import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const headerProps = {
  children: PropTypes.node.isRequired,
  underline: PropTypes.bool,
};

const headerDefaultProps = {
  underline: false,
};

const Header = ({ children, ...props }) =>
  <HeaderWrap {...props}>
    {children}
  </HeaderWrap>;

Header.propTypes = headerProps;
Header.defaultProps = headerDefaultProps;

const HeaderWrap = styled.h1`
  border-bottom: 1px solid ${
    props => props.underline
      ? props.theme['grey-normal']
      : 'transparent'
    };
  width: 100%;
`;

export default Header;
